// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3H0B6","info":"Note_info__3SMri","note":"Note_note__3BZE4","actions":"Note_actions__1hn25"};